import { ad } from "./ad";
import { ak } from "../c/ak";
import { du } from "../du";
import { mi } from "../i/r/mi";
import { ai } from "../i/r/ai";
import { msi } from "../i/msi/msi";
import { sb } from "../i/s/sb";


const group = {
    _ad: ad,
    _ak: ak,
    _du: du,
    _mi: mi,
    _ai: ai,
    _msi: msi,
    _sb: sb
}

export {group}